import { hidePageLoad, showPageLoad } from '../../../modules/actions'
import { customAxios as axios, getToken } from '../../../request'
import { getConferenceInterestsUrl, deleteConferenceInterestUrl, exportConferenceInterestUrl } from '../apis'

export const getConferenceInterests = filters => async dispatch => {
    dispatch(showPageLoad())
    let config = {
        params: { ...filters },
        ...getToken()
    }
    try {
        let { data } = await axios.get(getConferenceInterestsUrl(), config)
        dispatch(hidePageLoad())
        return data
    } catch (error) {
        dispatch(hidePageLoad())
        console.error('Error fetching conference interests:', error)
        return { error: true, message: error.message }
    }
}

export const deleteConferenceInterest = (id) => async (dispatch) => {
    dispatch(showPageLoad())
    try {
        let { data } = await axios.delete(deleteConferenceInterestUrl(id), getToken())
        dispatch(hidePageLoad())
        return data
    } catch (error) {
        dispatch(hidePageLoad())
        console.error('Error deleting conference interest:', error)
        return { error: true, message: error.message }
    }
}
export const exportConferenceInterestsFxn = (data) => async dispatch => {
    dispatch(showPageLoad())
    try {
        let resp = await axios.post(exportConferenceInterestUrl(), data, getToken())
        dispatch(hidePageLoad())
        return resp.data
    } catch (error) {
        dispatch(hidePageLoad())
        console.error('Error exporting conference interests:', error)
        return { error: true, message: error.message }
    }
}
